import type { GetAudienceCategoriesReachQuery } from '../../../../../../graphql/query/audiences/GetAudienceCategoriesReach.generated';
import type { AudienceInsightsContext } from './audienceInsights';
import { TOTAL_ID } from './audienceInsights';

export const mapToStatistics = (
  input: GetAudienceCategoriesReachQuery | undefined,
  publisherId: string = TOTAL_ID
): AudienceInsightsContext['statistics'] => {
  const data = input?.audience_categories_reach_all?.find(publisher => publisher?.sfAccountId === publisherId);

  if (!data) {
    return {
      totalMonthly: 0,
      totalActiveUsers: 0,
      totalActiveRampids: 0,

      totalDesktop: 0,
      totalMobileApp: 0,
      totalCTV: 0,
      totalTablets: 0,

      totalRequestDisplay: 0,
      totalRequestVideo: 0,
      totalRequestMobileApp: 0,
      totalRequestMobileWeb: 0,
      totalRequestDesktop: 0,
      totalRequestCTV: 0,
      totalRequestIP: 0,
      totalRequestDisplayPercent: 0,
      totalRequestVideoPercent: 0,
      totalRequestMobileAppPercent: 0,
      totalRequestMobileWebPercent: 0,
      totalRequestDesktopPercent: 0,
      totalRequestCTVPercent: 0,
      totalRequestIPPercent: 0,
    };
  }

  const totalRequestSum =
    (data.display || 0) +
    (data.video || 0) +
    (data.mobileapp || 0) +
    (data.mobileweb || 0) +
    (data.desktop || 0) +
    (data.connectedtv || 0) +
    (data.ip || 0);

  return {
    totalMonthly: data.total ?? 0,
    totalActiveUsers: data.totalmau ?? 0,
    totalActiveRampids: (data.idlXyWithRequests ?? 0) + (data.idlXiWithRequests ?? 0),

    totalDesktop: data.cookiesWithRequests ?? 0,
    totalMobileApp: data.mobileDevicesWithRequests ?? 0,
    totalCTV: data.uniqueConnectedTVDeviceIDsWithRequests ?? 0,
    totalTablets: data.tablet ?? 0,

    totalRequestDisplay: data.display ?? 0,
    totalRequestDisplayPercent: totalRequestSum > 0 ? ((data.display || 0) / totalRequestSum) * 100 : 0,
    totalRequestVideo: data.video ?? 0,
    totalRequestVideoPercent: totalRequestSum > 0 ? ((data.video || 0) / totalRequestSum) * 100 : 0,
    totalRequestMobileApp: data.mobileapp ?? 0,
    totalRequestMobileAppPercent: totalRequestSum > 0 ? ((data.mobileapp || 0) / totalRequestSum) * 100 : 0,
    totalRequestMobileWeb: data.mobileweb ?? 0,
    totalRequestMobileWebPercent: totalRequestSum > 0 ? ((data.mobileweb || 0) / totalRequestSum) * 100 : 0,
    totalRequestDesktop: data.desktop ?? 0,
    totalRequestDesktopPercent: totalRequestSum > 0 ? ((data.desktop || 0) / totalRequestSum) * 100 : 0,
    totalRequestCTV: data.connectedtv ?? 0,
    totalRequestCTVPercent: totalRequestSum > 0 ? ((data.connectedtv || 0) / totalRequestSum) * 100 : 0,
    totalRequestIP: data.ip ?? 0,
    totalRequestIPPercent: totalRequestSum > 0 ? ((data.ip || 0) / totalRequestSum) * 100 : 0,
  };
};
